// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './vuex';

router.beforeEach((to, from, next) => {   // Here to customize your router's actions.
  window.scrollTo(0, 0);

  const isLogin = store.getters.isLogin;
  if (!isLogin && to.path !== '/login') {
    next({ path: '/login', replace: true });
  } else {
    next();
  }
});

import { sync } from 'vuex-router-sync';
sync(store, router);

import element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(element);

Vue.config.productionTip = false;

import envConf from '../config/env.conf';
Vue.prototype.$env = envConf[process.env.BUILD_MODE];

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js